<template>
  <d-card class="card-small mb-4">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" lg="4">
          <h6 class="m-0">{{ title }}</h6>
        </d-col>
      </d-row>
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col md="12">
            <table class="table mb-0 table-striped">
              <tbody>
                <tr>
                  <td>
                    <ul class="options">
                      <li v-for="option in model.equipments" :key="option.id">
                        <span class="label delete" @click="deleteOption(option)">
                          <i class="material-icons">delete</i>
                        </span>
                        <span class="label" @click="openOption(option)">{{ option.name }}</span>
                      </li>
                      <li>
                        <span class="label" @click="openOption()">+ Novo equipamento</span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </d-col>
        </d-row>
        <d-row v-if="model.equipments.length === 0">
          <d-col class="no-content p-4">{{ emptyMessage }}</d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { EQUIPMENT_DEFAULT } from '_constants/equipment';

export default {
  name: 'Equipments',
  props: {
    title: {
      type: String,
      default: 'Lista de Equipamentos',
    },
    emptyMessage: {
      type: String,
      default: 'Ainda não foi cadastrado nenhum equipamento.',
    },
    model: {
      type: Object,
      required: true,
    },
    loadEvent: {
      type: String,
      required: true,
    },
    reloadEvent: {
      type: String,
      required: true,
    },
    deleteEvent: {
      type: String,
      required: true,
    },
  },
  methods: {
    ...mapActions(['setToggle', 'activeAlert']),
    deleteOption(option) {
      Events.$emit(this.deleteEvent, { entityId: this.model.id, equipmentId: option.id });
      this.setToggle({ type: 'confirm_modal', bool: true });
    },
    updateEquipments(equipment) {
      let index = Object.values(this.model.equipments).findIndex(row => row.id === equipment.id);
      if (index === -1) index = this.model.equipments.length;
      this.$set(this.model.equipments, index, equipment);
      this.$emit('update:model', this.model);
    },
    openOption(option = EQUIPMENT_DEFAULT) {
      Events.$emit(this.loadEvent, { id: this.model.id, option });
      this.setToggle({ type: 'add_equipment_modal', bool: true });
    },
  },
  mounted() {
    Events.$on(this.reloadEvent, equipment => {
      this.updateEquipments(equipment);
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';
.delete {
  cursor: pointer;
  margin-right: 7px;
}
.options {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: center;
  margin-bottom: 0;
  padding-left: 0;
  li {
    padding: 5px;
    border: 1px dashed #ff6d00;
    border-radius: 4px;
    margin-right: 5px;
    margin-bottom: 10px;
    background: $info;
    color: #ff6d00;
    font-size: 12px;
    cursor: pointer;
    &:hover {
      background: #ff6d00;
      color: #ffffff;
    }
  }
}
</style>
